<ion-header>
  <ion-toolbar color="primary">
    <ion-title>{{ 'DOCUMENTS.PDF_VIEWER.TITLE' | transloco }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content scrollY="false">
  <ng2-pdfjs-viewer #pdfViewer [showSpinner]="false" [urlValidation]="false" />
</ion-content>
